export default {
  data() {
    return {
      searchTitle: '',
      terminehTableHeaders: [
        { text: '', value: 'status', align: 'center' },
        { text: 'تاریخ', value: 'creationDate', align: 'center' },
        { text: 'مقصد', value: 'emergencyMedicalCenterTitle', align: 'center' },
        { text: 'آدرس', value: 'address', align: 'right' },
        { text: 'شماره تلفن', value: 'phoneNumber', align: 'center' },
        { text: 'تشخیص', value: 'diagnosisTitle', align: 'center' },
        { text: 'کد آمبولانس', value: 'missionCode', align: 'center' },
        { text: 'وضعیت', value: 'currentState', align: 'center' },
        { text: 'نام کاربر', value: 'fullName', align: 'center' },
        { text: 'عملیات', value: 'action', align: 'center' },
      ],
      isClosingTerminehModalOpen: false,
      missionId: null,
    };
  },
  methods: {
    openClosingTerminehModal: function (missionId) {
      this.isClosingTerminehModalOpen = true;
      this.missionId = missionId;
    },
    closeClosingTerminehModal: function () {
      this.isClosingTerminehModalOpen = false;
      this.missionId = null;
    },
  },
};
